import { render, staticRenderFns } from "./AIChat.vue?vue&type=template&id=5874e65e&scoped=true&"
import script from "./AIChat.vue?vue&type=script&setup=true&lang=js&"
export * from "./AIChat.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AIChat.vue?vue&type=style&index=0&id=5874e65e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5874e65e",
  null
  
)

export default component.exports